










import { Vue, Component, Prop } from "vue-property-decorator";

import CopyAddressButton from "@/views/components/CopyAddressButton.vue";
import SelectDefaultHub from "@/views/components/SelectDefaultHub.vue";

@Component({
  name: "SelectDefaultHubDialog",
  components: {
    CopyAddressButton,
    SelectDefaultHub,
  },
})
export default class SelectDefaultHubDialog extends Vue {
  private close() {
    this.$emit("dialog:clickClose");
  }
}
